module.exports = __webpack_public_path__ + "static/0015-a7657d0707735e2d8d675e3297db3a6a.png";